import {
  JsonApiControllerService as JsonApiService,
  RemoteParticipantJsonApiControllerService as RemoteService,
} from 'data/openapi';

// the same users logic will be for Remote participant and participant, so let's create simple "fabric" function
// which will decide what the ControllerService should be return
// v.1.1 after server changed methods, on the client side also was have done changes
export const useControllerService = (isRemote: boolean) => {
  return {
    getRequest: isRemote ? RemoteService.getRemoteParticipantRequest : JsonApiService.getParticipantRequest,
    postRequest: isRemote ? RemoteService.postRemoteParticipantRequest : JsonApiService.postParticipantRequest,
    patchRequest: isRemote ? RemoteService.postRemoteParticipantRequest : JsonApiService.patchParticipantRequest,
    deleteRequest: isRemote ? RemoteService.deleteRemoteParticipantRequest : JsonApiService.deleteParticipantRequest,
  };
};
